import { render, staticRenderFns } from "./teacherCaseTags.vue?vue&type=template&id=08a8d773&scoped=true"
import script from "./teacherCaseTags.vue?vue&type=script&lang=js"
export * from "./teacherCaseTags.vue?vue&type=script&lang=js"
import style0 from "./teacherCaseTags.vue?vue&type=style&index=0&id=08a8d773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a8d773",
  null
  
)

export default component.exports